import React from "react";

import type { IconDefinition } from "@fortawesome/fontawesome-common-types";

import { FontAwesomeIcon } from "@performyard/fontawesome/react-fontawesome";

type SuggestedAction = {
	label: string;
	icon?: IconDefinition;
	onClick: () => void;
};

type SuggestedActionsProps = {
	actions: SuggestedAction[];
};

export const SuggestedActions: React.FC<SuggestedActionsProps> = ({ actions }) => {
	if (actions.length === 0) return null;
	return (
		<div className="flex flex-col items-start gap-1">
			{actions.map((a) => (
				<button
					key={a.label}
					type="button"
					onClick={a.onClick}
					className="inline-flex items-center gap-1 border-none bg-transparent p-0 text-caption font-semibold text-primary-5 hover:cursor-pointer hover:text-primary-7 hover:underline active:text-primary-8 active:underline"
				>
					{a.icon && <FontAwesomeIcon icon={a.icon} style={{ fontSize: "9px" }} />}
					<span className="whitespace-nowrap">{a.label}</span>
				</button>
			))}
		</div>
	);
};
